<template>
  <div class="page flex-col">
    <div class="back">
      <BackButton />
    </div>

    <div class="container flex-col">
      <div class="class_profile_card flex-col">
        <span class="profile_title">班级资料</span>
        <div class="title_divider flex-col"></div>

        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">学年</span>
          <span class="info_value">{{ info.academicYear }}</span>
        </div>
        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">班级</span>
          <span class="info_value">{{ info.classId }}</span>
        </div>
        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">显示名称</span>
          <span class="info_value">{{ info.className }}</span>
        </div>
        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">显示人数</span>
          <span class="info_value">{{ info.studentCount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useStore } from "vuex"

import BackButton from "@/components/teacher/BackButton.vue"

const info = ref({
  academicYear: "2024-2025",
  classId: "test001",
  className: "TestClass",
  studentCount: 3,
})
const store = useStore()

onMounted(() => {
  if (store.getters.getCurrentClass) {
    info.value = store.getters.getCurrentClass
  }
})
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: 56.25vw;
  overflow: hidden;
}

.back {
  margin: 0.6vw 0 0 1.25vw;
}

.container {
  position: relative;
  width: 80.68vw;
  height: 20vw;
  margin-left: 1.25vw;
  margin-top: 0.6vw;
}

.class_profile_card {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;
  height: 20.52vw;
  width: 30.68vw;
  justify-content: flex-center;
  margin-top: 0.2vw;
}

.profile_title {
  width: 4.59vw;
  height: 1.52vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.14vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.15vw;
  margin: 2.91vw 0 0 2.65vw;
}

.title_divider {
  background-color: rgba(104, 162, 250, 0.6);
  width: 7.45vw;
  height: 0.11vw;
  margin: 0.62vw 0 0 2.65vw;
}

.info_label {
  width: 4.17vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(160, 174, 188, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
}

.info_value {
  width: 17.61vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
}

.profile_info_row {
  width: 24.38vw;
  height: 1.25vw;
  margin: 1.25vw 0 0 2.65vw;
}

.profile_info_row:last-of-type {
  margin-bottom: 4.42vw;
}
</style>
